import { ReactNode } from "react";
import MuiCard from "@material-ui/core/Card";
import styles from "./Card.module.scss";

interface CardProps {
  children: ReactNode;
  className?: string;
}

/**
 * Card component wrapper using Material UI
 */
export const Card = ({ children, className = "" }: CardProps) => {
  return (
    <MuiCard className={`${styles.card} ${className}`}>{children}</MuiCard>
  );
};
